import React from 'react'
import { OpenEventsMarketplace } from './OpenEventsMarketplace'

export const EventsPageMain = (): JSX.Element => {
  return (
    <>
      <OpenEventsMarketplace />
    </>
  )
}
